import { Pipe, PipeTransform } from '@angular/core';
import { CityService } from 'src/generated_client';

@Pipe({
  name: 'getBannerCity'
})
export class GetBannerCityPipe implements PipeTransform {

  city: any;

  constructor(
    public cityService: CityService
  ) { }

  async transform(id: number) {
    await this.cityService.apiCityGetByIdGet(id).toPromise().then(x => {
      this.city = x.dsName
    });
    return this.city;
  }

}
